// The routes this module owns, as the app mounts them. `route.ts` takes its mount from here and
// `src/app/paths.ts` merges this into the one `paths` object, so a link and a route cannot drift.
type Id = string | number | undefined;

export const computePaths = {
  base: '/services/compute',
  /** One Compute service (its console root). */
  service: (serviceId: Id) => `/services/compute/${serviceId}`,
  /** The instance list of a service. */
  instances: (serviceId: Id) => `/services/compute/${serviceId}/instances`,
  /** One instance of a service. */
  instance: (serviceId: Id, instanceId: Id) => `/services/compute/${serviceId}/instances/${instanceId}`,
  /** The full-window console popup of an instance (a pattern, for the router). */
  instanceConsole: '/services/compute/:serviceId/instances/:instanceId/console',
} as const;
